export default __webpack_public_path__ + "static/media/rfcheckout_1.38bb8212.png";